// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PHN2ZyBzdHJva2U9IndoaXRlIiBmaWxsPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIwIiB2aWV3Qm94PSIwIDAgNDQ4IDUxMiIgaGVpZ2h0PSIxZW0iIHdpZHRoPSIxZW0iIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI1NiA4MGMwLTE3LjctMTQuMy0zMi0zMi0zMnMtMzIgMTQuMy0zMiAzMlYyMjRINDhjLTE3LjcgMC0zMiAxNC4zLTMyIDMyczE0LjMgMzIgMzIgMzJIMTkyVjQzMmMwIDE3LjcgMTQuMyAzMiAzMiAzMnMzMi0xNC4zIDMyLTMyVjI4OEg0MDBjMTcuNyAwIDMyLTE0LjMgMzItMzJzLTE0LjMtMzItMzItMzJIMjU2VjgweiI+PC9wYXRoPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS40MjggOEwxMiAxMC41NzMgMTAuNTcyIDEyIDggOS40MjggNS40MjggMTIgNCAxMC41NzMgNi41NzIgOCA0IDUuNDI4IDUuNDI3IDQgOCA2LjU3MiAxMC41NzMgNCAxMiA1LjQyOCA5LjQyOCA4eiIgZmlsbD0iI0U4RThFOCIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml;base64,PHN2ZyBzdHJva2U9IndoaXRlIiBmaWxsPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgaGVpZ2h0PSIxZW0iIHdpZHRoPSIxZW0iIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTI4OS45NCAyNTYgOTUtOTVBMjQgMjQgMCAwIDAgMzUxIDEyN2wtOTUgOTUtOTUtOTVhMjQgMjQgMCAwIDAtMzQgMzRsOTUgOTUtOTUgOTVhMjQgMjQgMCAxIDAgMzQgMzRsOTUtOTUgOTUgOTVhMjQgMjQgMCAwIDAgMzQtMzR6Ij48L3BhdGg+PC9zdmc+", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* http://meyerweb.com/eric/tools/css/reset/ 
   v2.0 | 20110126
   License: none (public domain)
*/

:root {
  --tar-700: #222222;
  --charchoal-700: #454545;
}

* {
  font-family: Consolas, "Andale Mono WT", "Andale Mono", "Lucida Console", "Lucida Sans Typewriter", "DejaVu Sans Mono", "Bitstream Vera Sans Mono", "Liberation Mono", "Nimbus Mono L", Monaco, "Courier New", Courier, monospace;
}

html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed, 
figure, figcaption, footer, header, hgroup, 
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure, 
footer, header, hgroup, menu, nav, section {
  display: block;
}
body {
  line-height: 1;
}
ol, ul {
  list-style: none;
}
blockquote, q {
  quotes: none;
}
blockquote:before, blockquote:after,
q:before, q:after {
  content: '';
  content: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}

html {
  color: #ccc;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  position: fixed;
}

body {
  width: 100%;
  height: 100%;
  border: 0;
  background: rgb(21, 21, 21);
  display: flex;
  flex-direction: column;
}

button {
  cursor: pointer;
  background: none;
  outline: none;
  border: none;
  color: white;
}

code {
  background: rgba(0,0,0,0.6);
  padding: 20px;
}

@keyframes pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 156, 101, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(255, 156, 101, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 156, 101, 0);
  }
}

header {
  height: 50px;
  padding: 10px 30px;
  border-bottom: 1px solid #333;
  display: flex;
  justify-content: space-between;
  flex-shrink: initial;
  align-items: center;
}

header .group {
  display: flex;
  align-items: center;
}

header .group > * {
  margin-left: 10px;
}

header .group > *:not(:last-child) {
  margin-right: 10px;
}

main {
  display: flex;
  flex: 1;
  flex-direction: row;
}

#editor {
  position: relative;
  height: 100%;
  width: 50%;
}

#editor-tabs {
  height: 35px;
  display: flex;
  flex-direction: row;
  overflow: scroll;
  flex-direction: row;
}

#editor-tabs li {
  cursor: pointer;
  padding-left: 10px;
  display: flex;
  background: #333;
  align-items: center;
  border-right: 1px solid rgb(36, 36, 36);
  background-color: rgb(21, 21, 21);
  min-width: 50px;
}

#editor-tabs li.create {
  margin-left: auto;
  width: 30px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) 50% 50% no-repeat;
}

#editor-tabs li.active {
  border-bottom: 1px solid #007bff;
}

#editor-tabs li:focus {
  outline: none;
  border-bottom: 1px solid #007bff;
}

#editor-tabs li.active .close-btn {
  visibility: initial;
}

#editor-tabs li .close-btn {
  visibility: hidden;
  width: 20px;
  height: 20px;
  margin: 0 5px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) 50% no-repeat;
}

#editor-tabs li:hover .close-btn {
  visibility: initial;
}

#editor-tabs li .close-btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

#side-nav {
  width: 50px;
  background: #111;
  height: 100%;
  flex-direction: column;
  border-right: 1px solid #333;
}

#side-nav input[type="radio"]  {
  display: none;
}

#side-nav input[type="radio"] + label {
  cursor: pointer;
  padding: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #333;
  color: white;
  height: 20px;
}

#side-nav input[type="radio"]:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

#code {
  height: calc(100vh - 106px);
}

#runner {
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
}

#viewer, #devtools {
  display: flex;
  flex: 1;
}

#devtools iframe {
  border: none;
  overflow: hidden;
  width: 100%;
}

#settings #close-settings {
  position: absolute;
  top: 20px;
  left: 20px;
}

#settings, #sessions {
  display: none;
  position: absolute;
  top: 20px;
  left: 20px;
  bottom: 20px;
  right: 20px;
  background: #111;
  box-shadow: 0px 0px 10px #111;
  padding: 20px;
  max-width: 500px;
  border: 1px solid #adadad;
}

#settings h2,
#sessions h2 {
  text-align: center;
  font-size: 20px;
  margin-bottom: 20px;
}

#settings input[type="text"],
#settings input[type="url"],
#settings input[type="number"],
#settings textarea {
  width: 60%;
  background: transparent;
  color: white;
  padding: 5px;
  outline: none;
  border: 1px solid #aaa;
  resize: vertical;
}

#settings input[type="text"].error,
#settings input[type="url"].error,
#settings textarea.error {
  color: red;
  border-color: salmon;
}

#settings form {
  width: 100%;
}

#settings .form-input {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#settings .form-checkbox {
  display: flex;
  margin-bottom: 15px;
}

#sessions {
  flex-direction: column;
}

#sessions-viewer {
  margin: 20px 30px;
}

#sessions #close-sessions {
  position: absolute;
  top: 20px;
  left: 20px;
}

#sessions a {
  color: white;
  border-bottom: 1px dashed white;
}

.resizer-horizontal {
  width: 5px;
  background: #555;
  cursor: col-resize;
}

.resizer-vertical {
  height: 5px;
  background: #555;
  cursor: row-resize;
}

.fixed-message {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 123, 255, .1);
}

#editor-tabs {
  padding-top: 5px;
  margin-left: 1em;
}

#editor-tabs::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

#editor-tabs::-webkit-scrollbar-thumb{
  background: #626262 !important;
}



#editor-tabs::-webkit-scrollbar-corner {
  background: transparent;
}

/* V2 styles */

:root {
  --tar-700: #222222;
  --charchoal-700: #454545;
}

* {
  font-family: "Fira Code", monospace;
}

header .logo {
  display: flex;
  gap: 1em;
  align-items: center;
  font-size: 14pt;
  color: #a3a3a3;
  font-family: "Fira Code", monospace !important;
  cursor: default !important;
}

header,
#editor-tabs,
#side-nav {
  background-color: var(--tar-700);
  color: white;
}

#settings,
#sessions {
  border-radius: 0.375rem;
  background-color: rgba(34, 34, 34, 0.8) !important;
  backdrop-filter: blur(24px);
  border: 1px solid var(--charchoal-700);
}

#settings .form-input {
  flex-direction: column;
  justify-content: start;
  align-items: start;
  gap: 0.5em;
}

#settings input[type="text"],
#settings input[type="url"],
#settings input[type="number"],
#settings textarea {
  letter-spacing: normal;
  margin: 0px 0px 24px;
  box-sizing: border-box;
  color: rgb(250, 250, 250);
  font-feature-settings: normal;
  font-size: 16px;
  font-variation-settings: normal;
  font-weight: 600;
  line-height: 24px;
  padding: 8px 16px;
  width: 486px;
  border-radius: 4px;
  background-color: rgb(57, 57, 57);
  outline: rgba(0, 0, 0, 0) solid 2px;
  outline-offset: 2px;
  color-scheme: dark;
  overflow: visible;
  border: 1px solid rgb(115, 115, 115);
}

#settings h2,
#sessions h2 {
  box-sizing: border-box;
  margin-bottom: 1em;
  font-size: 24px;
  font-weight: 600;
  color: rgb(250, 250, 250);
}

#settings #close-settings {
  left: calc(100% - 65px);
}

.form-input label {
  box-sizing: border-box;
  font-weight: 600;
  color: rgb(250, 250, 250);
  line-height: 24px;
}

#run-button {
  color: rgb(255, 255, 255);
  font-size: 14.875px;
  text-decoration: none solid rgb(255, 255, 255);
  background-color: rgb(245, 0, 122) !important;
  outline: rgb(255, 255, 255) none 0px;
  box-sizing: border-box;
  border-radius: 4.25px;
  cursor: pointer;
  display: block;
  line-height: 14.875px;
  padding: 13.821px 29.75px;
  box-shadow: inset 0 6px 16px rgba(255, 255, 255, 0.2),
    inset 0 1px 2px rgba(255, 255, 255, 0.2),
    inset 1px 1px 1px rgba(255, 255, 255, 0.05);
  flex: 0 0 auto;
  font-weight: 700;
  text-align: center;
  transition: all 0.13s ease 0s;
  font-family: Urbanist, Arial, sans-serif;
}

div#code {
  border-radius: 0.375rem !important;
  padding: 12px;
  background: rgb(34 34 34);
  height: 92.6%;
}

#editor-tabs li {
  background: rgb(34 34 34);
  border-radius: 0.35em;
}

#editor-tabs li.active {
  background: #454545;
  border-bottom: unset !important;
}

#editor-tabs li .close-btn {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___})
    50% no-repeat;
}

.monaco-editor[role="code"] {
  padding-top: 1em;
}

.monaco-editor,
.monaco-editor-background,
.monaco-editor .inputarea.ime-input,
.monaco-editor .margin {
  background: #171717 !important;
}

.monaco-editor[role="code"],
.monaco-scrollable-element.editor-scrollable.vs-dark {
  border-top-right-radius: 1em !important;
  border-bottom-right-radius: 1em !important;
}

.monaco-editor[role="code"],
.monaco-editor .overflow-guard > div.margin[role="presentation"] {
  border-top-left-radius: 1em !important;
  border-bottom-left-radius: 1em !important;
}

.fixed-message {
  width: 95%;
  height: 95%;
  border-radius: 1em;
  margin-left: 1em;
  margin-top: 2em;
}

.resizer-horizontal {
  width: 2px;
  background: transparent !important;
}

.resizer-horizontal:hover {
  background: #555 !important;
}

div#editor {
  max-height: 90vh;
}

body {
  background: var(--tar-700);
}

canvas#screencast {
  border-top-left-radius: 1em;
  border-top-right-radius: 1em;

  width: 95%;
  height: 95%;
  margin-left: 1em;
  margin-top: 2em;
}

#devtools iframe {
  border-bottom-left-radius: 1em;
  border-bottom-right-radius: 1em;

  width: 95%;
  height: 95%;
  margin-left: 1em;
}

#side-nav input[type="radio"]:hover + label,
#side-nav input[type="radio"]:checked + label {
  background: #454545;
}

#side-nav input[type="radio"] + label {
  border-radius: 0.35em;
  margin-left: 0.35em;
}

div.form-input p.form-descriptor {
  box-sizing: border-box;
  color: #9b9b9b;
  line-height: 1em;
  font-size: 10pt;
  cursor: default;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;CAGC;;AAED;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,iOAAiO;AACnO;;AAEA;;;;;;;;;;;;;EAaE,SAAS;EACT,UAAU;EACV,SAAS;EACT,eAAe;EACf,aAAa;EACb,wBAAwB;AAC1B;AACA,gDAAgD;AAChD;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;;EAEE,WAAW;EACX,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,MAAM;EACN,OAAO;EACP,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE;IACE,sBAAsB;IACtB,4CAA4C;EAC9C;;EAEA;IACE,mBAAmB;IACnB,6CAA6C;EAC/C;;EAEA;IACE,sBAAsB;IACtB,0CAA0C;EAC5C;AACF;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,qEAAigB;AACngB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,iEAAyZ;AAC3Z;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;EACb,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;;EAIE,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;;EAGE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;;;AAIA;EACE,uBAAuB;AACzB;;AAEA,cAAc;;AAEd;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,8CAA8C;EAC9C,0BAA0B;AAC5B;;AAEA;;;EAGE,gCAAgC;EAChC,YAAY;AACd;;AAEA;;EAEE,uBAAuB;EACvB,kDAAkD;EAClD,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;;;EAIE,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;;EAEE,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,6CAA6C;EAC7C,oCAAoC;EACpC,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB;;+CAE6C;EAC7C,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,aAAa;EACb,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE;iBACe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;EAIE,8BAA8B;AAChC;;AAEA;;EAEE,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;;EAEE,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;;EAE5B,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;;EAE/B,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB","sourcesContent":["/* http://meyerweb.com/eric/tools/css/reset/ \n   v2.0 | 20110126\n   License: none (public domain)\n*/\n\n:root {\n  --tar-700: #222222;\n  --charchoal-700: #454545;\n}\n\n* {\n  font-family: Consolas, \"Andale Mono WT\", \"Andale Mono\", \"Lucida Console\", \"Lucida Sans Typewriter\", \"DejaVu Sans Mono\", \"Bitstream Vera Sans Mono\", \"Liberation Mono\", \"Nimbus Mono L\", Monaco, \"Courier New\", Courier, monospace;\n}\n\nhtml, body, div, span, applet, object, iframe,\nh1, h2, h3, h4, h5, h6, p, blockquote, pre,\na, abbr, acronym, address, big, cite, code,\ndel, dfn, em, img, ins, kbd, q, s, samp,\nsmall, strike, strong, sub, sup, tt, var,\nb, u, i, center,\ndl, dt, dd, ol, ul, li,\nfieldset, form, label, legend,\ntable, caption, tbody, tfoot, thead, tr, th, td,\narticle, aside, canvas, details, embed, \nfigure, figcaption, footer, header, hgroup, \nmenu, nav, output, ruby, section, summary,\ntime, mark, audio, video {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n}\n/* HTML5 display-role reset for older browsers */\narticle, aside, details, figcaption, figure, \nfooter, header, hgroup, menu, nav, section {\n  display: block;\n}\nbody {\n  line-height: 1;\n}\nol, ul {\n  list-style: none;\n}\nblockquote, q {\n  quotes: none;\n}\nblockquote:before, blockquote:after,\nq:before, q:after {\n  content: '';\n  content: none;\n}\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\nhtml {\n  color: #ccc;\n  height: 100%;\n  width: 100%;\n  top: 0;\n  left: 0;\n  position: fixed;\n}\n\nbody {\n  width: 100%;\n  height: 100%;\n  border: 0;\n  background: rgb(21, 21, 21);\n  display: flex;\n  flex-direction: column;\n}\n\nbutton {\n  cursor: pointer;\n  background: none;\n  outline: none;\n  border: none;\n  color: white;\n}\n\ncode {\n  background: rgba(0,0,0,0.6);\n  padding: 20px;\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(0.95);\n    box-shadow: 0 0 0 0 rgba(255, 156, 101, 0.7);\n  }\n\n  70% {\n    transform: scale(1);\n    box-shadow: 0 0 0 10px rgba(255, 156, 101, 0);\n  }\n\n  100% {\n    transform: scale(0.95);\n    box-shadow: 0 0 0 0 rgba(255, 156, 101, 0);\n  }\n}\n\nheader {\n  height: 50px;\n  padding: 10px 30px;\n  border-bottom: 1px solid #333;\n  display: flex;\n  justify-content: space-between;\n  flex-shrink: initial;\n  align-items: center;\n}\n\nheader .group {\n  display: flex;\n  align-items: center;\n}\n\nheader .group > * {\n  margin-left: 10px;\n}\n\nheader .group > *:not(:last-child) {\n  margin-right: 10px;\n}\n\nmain {\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n}\n\n#editor {\n  position: relative;\n  height: 100%;\n  width: 50%;\n}\n\n#editor-tabs {\n  height: 35px;\n  display: flex;\n  flex-direction: row;\n  overflow: scroll;\n  flex-direction: row;\n}\n\n#editor-tabs li {\n  cursor: pointer;\n  padding-left: 10px;\n  display: flex;\n  background: #333;\n  align-items: center;\n  border-right: 1px solid rgb(36, 36, 36);\n  background-color: rgb(21, 21, 21);\n  min-width: 50px;\n}\n\n#editor-tabs li.create {\n  margin-left: auto;\n  width: 30px;\n  background: url(data:image/svg+xml;base64,PHN2ZyBzdHJva2U9IndoaXRlIiBmaWxsPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIwIiB2aWV3Qm94PSIwIDAgNDQ4IDUxMiIgaGVpZ2h0PSIxZW0iIHdpZHRoPSIxZW0iIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI1NiA4MGMwLTE3LjctMTQuMy0zMi0zMi0zMnMtMzIgMTQuMy0zMiAzMlYyMjRINDhjLTE3LjcgMC0zMiAxNC4zLTMyIDMyczE0LjMgMzIgMzIgMzJIMTkyVjQzMmMwIDE3LjcgMTQuMyAzMiAzMiAzMnMzMi0xNC4zIDMyLTMyVjI4OEg0MDBjMTcuNyAwIDMyLTE0LjMgMzItMzJzLTE0LjMtMzItMzItMzJIMjU2VjgweiI+PC9wYXRoPjwvc3ZnPg==) 50% 50% no-repeat;\n}\n\n#editor-tabs li.active {\n  border-bottom: 1px solid #007bff;\n}\n\n#editor-tabs li:focus {\n  outline: none;\n  border-bottom: 1px solid #007bff;\n}\n\n#editor-tabs li.active .close-btn {\n  visibility: initial;\n}\n\n#editor-tabs li .close-btn {\n  visibility: hidden;\n  width: 20px;\n  height: 20px;\n  margin: 0 5px;\n  background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS40MjggOEwxMiAxMC41NzMgMTAuNTcyIDEyIDggOS40MjggNS40MjggMTIgNCAxMC41NzMgNi41NzIgOCA0IDUuNDI4IDUuNDI3IDQgOCA2LjU3MiAxMC41NzMgNCAxMiA1LjQyOCA5LjQyOCA4eiIgZmlsbD0iI0U4RThFOCIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=) 50% no-repeat;\n}\n\n#editor-tabs li:hover .close-btn {\n  visibility: initial;\n}\n\n#editor-tabs li .close-btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n#side-nav {\n  width: 50px;\n  background: #111;\n  height: 100%;\n  flex-direction: column;\n  border-right: 1px solid #333;\n}\n\n#side-nav input[type=\"radio\"]  {\n  display: none;\n}\n\n#side-nav input[type=\"radio\"] + label {\n  cursor: pointer;\n  padding: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-bottom: 1px solid #333;\n  color: white;\n  height: 20px;\n}\n\n#side-nav input[type=\"radio\"]:hover {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n#code {\n  height: calc(100vh - 106px);\n}\n\n#runner {\n  position: relative;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n}\n\n#viewer, #devtools {\n  display: flex;\n  flex: 1;\n}\n\n#devtools iframe {\n  border: none;\n  overflow: hidden;\n  width: 100%;\n}\n\n#settings #close-settings {\n  position: absolute;\n  top: 20px;\n  left: 20px;\n}\n\n#settings, #sessions {\n  display: none;\n  position: absolute;\n  top: 20px;\n  left: 20px;\n  bottom: 20px;\n  right: 20px;\n  background: #111;\n  box-shadow: 0px 0px 10px #111;\n  padding: 20px;\n  max-width: 500px;\n  border: 1px solid #adadad;\n}\n\n#settings h2,\n#sessions h2 {\n  text-align: center;\n  font-size: 20px;\n  margin-bottom: 20px;\n}\n\n#settings input[type=\"text\"],\n#settings input[type=\"url\"],\n#settings input[type=\"number\"],\n#settings textarea {\n  width: 60%;\n  background: transparent;\n  color: white;\n  padding: 5px;\n  outline: none;\n  border: 1px solid #aaa;\n  resize: vertical;\n}\n\n#settings input[type=\"text\"].error,\n#settings input[type=\"url\"].error,\n#settings textarea.error {\n  color: red;\n  border-color: salmon;\n}\n\n#settings form {\n  width: 100%;\n}\n\n#settings .form-input {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n#settings .form-checkbox {\n  display: flex;\n  margin-bottom: 15px;\n}\n\n#sessions {\n  flex-direction: column;\n}\n\n#sessions-viewer {\n  margin: 20px 30px;\n}\n\n#sessions #close-sessions {\n  position: absolute;\n  top: 20px;\n  left: 20px;\n}\n\n#sessions a {\n  color: white;\n  border-bottom: 1px dashed white;\n}\n\n.resizer-horizontal {\n  width: 5px;\n  background: #555;\n  cursor: col-resize;\n}\n\n.resizer-vertical {\n  height: 5px;\n  background: #555;\n  cursor: row-resize;\n}\n\n.fixed-message {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 123, 255, .1);\n}\n\n#editor-tabs {\n  padding-top: 5px;\n  margin-left: 1em;\n}\n\n#editor-tabs::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n#editor-tabs::-webkit-scrollbar-thumb{\n  background: #626262 !important;\n}\n\n\n\n#editor-tabs::-webkit-scrollbar-corner {\n  background: transparent;\n}\n\n/* V2 styles */\n\n:root {\n  --tar-700: #222222;\n  --charchoal-700: #454545;\n}\n\n* {\n  font-family: \"Fira Code\", monospace;\n}\n\nheader .logo {\n  display: flex;\n  gap: 1em;\n  align-items: center;\n  font-size: 14pt;\n  color: #a3a3a3;\n  font-family: \"Fira Code\", monospace !important;\n  cursor: default !important;\n}\n\nheader,\n#editor-tabs,\n#side-nav {\n  background-color: var(--tar-700);\n  color: white;\n}\n\n#settings,\n#sessions {\n  border-radius: 0.375rem;\n  background-color: rgba(34, 34, 34, 0.8) !important;\n  backdrop-filter: blur(24px);\n  border: 1px solid var(--charchoal-700);\n}\n\n#settings .form-input {\n  flex-direction: column;\n  justify-content: start;\n  align-items: start;\n  gap: 0.5em;\n}\n\n#settings input[type=\"text\"],\n#settings input[type=\"url\"],\n#settings input[type=\"number\"],\n#settings textarea {\n  letter-spacing: normal;\n  margin: 0px 0px 24px;\n  box-sizing: border-box;\n  color: rgb(250, 250, 250);\n  font-feature-settings: normal;\n  font-size: 16px;\n  font-variation-settings: normal;\n  font-weight: 600;\n  line-height: 24px;\n  padding: 8px 16px;\n  width: 486px;\n  border-radius: 4px;\n  background-color: rgb(57, 57, 57);\n  outline: rgba(0, 0, 0, 0) solid 2px;\n  outline-offset: 2px;\n  color-scheme: dark;\n  overflow: visible;\n  border: 1px solid rgb(115, 115, 115);\n}\n\n#settings h2,\n#sessions h2 {\n  box-sizing: border-box;\n  margin-bottom: 1em;\n  font-size: 24px;\n  font-weight: 600;\n  color: rgb(250, 250, 250);\n}\n\n#settings #close-settings {\n  left: calc(100% - 65px);\n}\n\n.form-input label {\n  box-sizing: border-box;\n  font-weight: 600;\n  color: rgb(250, 250, 250);\n  line-height: 24px;\n}\n\n#run-button {\n  color: rgb(255, 255, 255);\n  font-size: 14.875px;\n  text-decoration: none solid rgb(255, 255, 255);\n  background-color: rgb(245, 0, 122) !important;\n  outline: rgb(255, 255, 255) none 0px;\n  box-sizing: border-box;\n  border-radius: 4.25px;\n  cursor: pointer;\n  display: block;\n  line-height: 14.875px;\n  padding: 13.821px 29.75px;\n  box-shadow: inset 0 6px 16px rgba(255, 255, 255, 0.2),\n    inset 0 1px 2px rgba(255, 255, 255, 0.2),\n    inset 1px 1px 1px rgba(255, 255, 255, 0.05);\n  flex: 0 0 auto;\n  font-weight: 700;\n  text-align: center;\n  transition: all 0.13s ease 0s;\n  font-family: Urbanist, Arial, sans-serif;\n}\n\ndiv#code {\n  border-radius: 0.375rem !important;\n  padding: 12px;\n  background: rgb(34 34 34);\n  height: 92.6%;\n}\n\n#editor-tabs li {\n  background: rgb(34 34 34);\n  border-radius: 0.35em;\n}\n\n#editor-tabs li.active {\n  background: #454545;\n  border-bottom: unset !important;\n}\n\n#editor-tabs li .close-btn {\n  background: url(data:image/svg+xml;base64,PHN2ZyBzdHJva2U9IndoaXRlIiBmaWxsPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgaGVpZ2h0PSIxZW0iIHdpZHRoPSIxZW0iIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTI4OS45NCAyNTYgOTUtOTVBMjQgMjQgMCAwIDAgMzUxIDEyN2wtOTUgOTUtOTUtOTVhMjQgMjQgMCAwIDAtMzQgMzRsOTUgOTUtOTUgOTVhMjQgMjQgMCAxIDAgMzQgMzRsOTUtOTUgOTUgOTVhMjQgMjQgMCAwIDAgMzQtMzR6Ij48L3BhdGg+PC9zdmc+)\n    50% no-repeat;\n}\n\n.monaco-editor[role=\"code\"] {\n  padding-top: 1em;\n}\n\n.monaco-editor,\n.monaco-editor-background,\n.monaco-editor .inputarea.ime-input,\n.monaco-editor .margin {\n  background: #171717 !important;\n}\n\n.monaco-editor[role=\"code\"],\n.monaco-scrollable-element.editor-scrollable.vs-dark {\n  border-top-right-radius: 1em !important;\n  border-bottom-right-radius: 1em !important;\n}\n\n.monaco-editor[role=\"code\"],\n.monaco-editor .overflow-guard > div.margin[role=\"presentation\"] {\n  border-top-left-radius: 1em !important;\n  border-bottom-left-radius: 1em !important;\n}\n\n.fixed-message {\n  width: 95%;\n  height: 95%;\n  border-radius: 1em;\n  margin-left: 1em;\n  margin-top: 2em;\n}\n\n.resizer-horizontal {\n  width: 2px;\n  background: transparent !important;\n}\n\n.resizer-horizontal:hover {\n  background: #555 !important;\n}\n\ndiv#editor {\n  max-height: 90vh;\n}\n\nbody {\n  background: var(--tar-700);\n}\n\ncanvas#screencast {\n  border-top-left-radius: 1em;\n  border-top-right-radius: 1em;\n\n  width: 95%;\n  height: 95%;\n  margin-left: 1em;\n  margin-top: 2em;\n}\n\n#devtools iframe {\n  border-bottom-left-radius: 1em;\n  border-bottom-right-radius: 1em;\n\n  width: 95%;\n  height: 95%;\n  margin-left: 1em;\n}\n\n#side-nav input[type=\"radio\"]:hover + label,\n#side-nav input[type=\"radio\"]:checked + label {\n  background: #454545;\n}\n\n#side-nav input[type=\"radio\"] + label {\n  border-radius: 0.35em;\n  margin-left: 0.35em;\n}\n\ndiv.form-input p.form-descriptor {\n  box-sizing: border-box;\n  color: #9b9b9b;\n  line-height: 1em;\n  font-size: 10pt;\n  cursor: default;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
